import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReviewItem from './ReviewItem';
import { connect } from 'react-redux';
import { isEmptyArray } from '../../../../../core/util/array';
import { reviewFilter } from '../../../../../core/util/rating';
import styled from 'styled-components';
import { colors } from '../../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../../constants/text';
import { smallerThan } from '../../../../../core/util/styledComponents';
import { pluralize } from '../../../../../core/util/string';

const Title = styled.div`
  color: ${colors.squid};
  font-size: ${fontSize.default};
  font-family: ${fontFamily.bold};
  line-height: 19px;
  margin-top: 12px;
  margin-bottom: -4px;

  ${smallerThan.sm`
    margin-bottom: -6px;
  `}
`;

class ReviewsList extends PureComponent {
  static propTypes = {
    reviews: PropTypes.array.isRequired,
    showModal: PropTypes.func,
    locationTimeZone: PropTypes.string,
  };

  render = () => {
    const { reviews, showModal, locationTimeZone } = this.props;
    const filteredReviews = reviews.filter(review => reviewFilter(review));
    const reviewsCount = filteredReviews.length;

    if (isEmptyArray(filteredReviews)) {
      return null;
    }

    return (
      <div>
        <Title>
          Showing {reviewsCount} Top {pluralize(reviewsCount, 'Review')}
        </Title>
        <div>
          {filteredReviews.map(review => (
            <ReviewItem
              key={review.id}
              rating={review.rating_solv}
              createdDate={review.created_date}
              description={review.review}
              helpfulCount={review.helpful_count}
              shouldShowVerified={!!review.booking_id}
              ratingId={review.id}
              showModal={showModal}
              locationTimeZone={locationTimeZone}
            />
          ))}
        </div>
      </div>
    );
  };
}

const mapStateToProps = state => ({
  locationTimeZone: state.location.timeZone,
  reviews: state.solvRatings,
});

export default connect(
  mapStateToProps,
  null
)(ReviewsList);
